import CloseMultipleTabsChannel from 'actions/multiple_tabs/close_multiple_tabs_channel';
import FlushUnsavedCompositions from 'actions/composition/flush_unsaved_compositions';

export default function configureWindowUnloadHandlers(context) {
  window.addEventListener('beforeunload', evt => {
    context.executeAction(FlushUnsavedCompositions, evt);
    context.executeAction(CloseMultipleTabsChannel);
  });
}
